module.exports = __webpack_public_path__ + "img/face-zany.17b0a381.svg";